import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MyAELayout } from "../components/myae/Layout";
import { listAnalyses } from "../lib/api";
import { FileText, Loader2, FolderOpen, ArrowUpRight, FilePlus2 } from "lucide-react";

const fmtDate = (s) => (s ? new Date(s).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—");

export default function DocumentsPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => { listAnalyses().then(setItems).catch(() => setItems([])); }, []);

  return (
    <MyAELayout>
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-8 sm:py-10" data-testid="documents-page">
        <div className="flex items-center justify-between gap-4 mb-8">
          <div>
            <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-zinc-900">Documents</h1>
            <p className="text-zinc-500 mt-1">Every submission you've analysed with MyAE.</p>
          </div>
          <button onClick={() => navigate("/new")} data-testid="documents-new-btn"
            className="inline-flex items-center gap-2 rounded-lg bg-indigo-600 px-4 py-2.5 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 transition-all active:scale-[0.98]">
            <FilePlus2 size={17} /> New Analysis
          </button>
        </div>

        {items === null ? (
          <div className="flex items-center gap-2 text-zinc-500 py-10"><Loader2 className="animate-spin" size={18} /> Loading…</div>
        ) : items.length === 0 ? (
          <div className="rounded-2xl border border-zinc-200 bg-white p-12 text-center" data-testid="documents-empty">
            <FolderOpen size={32} className="text-zinc-300 mx-auto mb-3" />
            <p className="font-medium text-zinc-900">No documents yet</p>
            <p className="text-sm text-zinc-500 mt-1">Documents you upload for analysis will appear here.</p>
          </div>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="documents-grid">
            {items.map((a) => (
              <div key={a.id} onClick={() => a.status === "complete" && navigate(`/report/${a.id}`)}
                data-testid={`document-card-${a.id}`}
                className="rounded-2xl border border-zinc-200 bg-white p-5 shadow-sm hover:shadow-md hover:border-indigo-200 transition-all cursor-pointer">
                <div className="flex items-start justify-between">
                  <div className="w-10 h-10 rounded-xl bg-indigo-50 flex items-center justify-center"><FileText size={18} className="text-indigo-600" /></div>
                  {a.status === "complete" && <ArrowUpRight size={16} className="text-zinc-400" />}
                </div>
                <p className="font-medium text-zinc-900 truncate mt-3" title={a.filename}>{a.filename || "Submission"}</p>
                <p className="text-xs text-zinc-400 mt-0.5">{fmtDate(a.created_at)} · {a.word_count || 0} words</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </MyAELayout>
  );
}
